module.exports = __webpack_public_path__ + "img/a.146a1417.png";